<template>
    <div id="app">
        <main-header nowtab="play"></main-header>
        <main v-if="tower" class="adjuster">
            <a-back-top />
            <Title>{{ tower.title }}</Title>
            <div class="description" v-html="tower.description"></div>
            <info-board :tower="tower" />
            <rating-board v-bind="rating" />
            <record-board :record="record" :competition="tower.competition > 0" />
            <comment-board :comments="comments" />
        </main>
        <page-404 v-else comment="该塔不存在或已下架" />
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Page404 from '@/components/Page404.vue'
import Title from '@/components/Title.vue'
import Footer from '@/components/Footer'
import InfoBoard from './panels/InfoBoard.vue'
import RecordBoard from './panels/RecordBoard.vue'
import RatingBoard from './panels/RatingBoard.vue'
import CommentBoard from './panels/CommentBoard.vue'
import { getSSRdata } from '../../utils/utils'

export default {
    data: () => ({
        tower: null,
        record: null,
        rating: null,
        myrate: null,
        focused: false,
        canComment: false,
        comments: null,
    }),
    provide() {
        return {
            app: this,
        }
    },
    created() {
        const { tower, record, rating, focused, canComment, comments } = getSSRdata('tower');
        document.title = `${ tower.title } - 作品主页 - HTML5魔塔广场`;
        this.tower = tower;
        this.record = record;
        this.rating = rating;
        this.focused = focused;
        this.canComment = canComment;
        this.comments = comments;
    },
    components: {
        MainHeader, Footer,
        InfoBoard,
        RatingBoard,
        RecordBoard,
        CommentBoard,
        Page404,
        Title,
    }
}
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    margin: 20px auto;
    div {
        margin-bottom: 30px;
    }
}
@media screen and (min-width: 1000px) {
    .adjuster {
        width: 1000px;
        .info-board-container, .rating-board-container {
            display: inline-block;
            margin-bottom: 0;
        }
    }
    .info-board-container {
        max-width: 550px;
        width: 550px;
        vertical-align: top;
    }
    .rating-board-container {
        max-width: 450px;
    }
}
@media screen and (max-width: 999px) {
    .adjuster {
        width: 100%;
    }
}
.description {
    text-align: left;
    margin: 0 15px;
}
</style>